import { fetcher, useSession } from 'services';
import { useEffect } from 'react';
import { useIndicatorsContext } from 'core/Indicators';

type NotificationScope = { comments?: boolean };

export function useNotificationSeen(object_key: string | null, scope?: NotificationScope) {
  const {
    invalidate,
    indicators: { unseen_notifications },
  } = useIndicatorsContext();
  const isImpresonation = useSession().impersonation !== null;

  // biome-ignore lint/correctness/useExhaustiveDependencies: mutate is stable
  useEffect(() => {
    if (isImpresonation || !unseen_notifications || !object_key) {
      return;
    }

    const timeoutId = setTimeout(async () => {
      const res = await fetcher<{ count: number }>({
        url: `notifications/notifications/mark_object_seen/`,
        method: 'POST',
        body: {
          context_object_key: object_key,
          ...(scope?.comments ? { comments: true } : {}),
        },
      });
      if (res.count) {
        invalidate('unseen_notifications');
      }
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, [object_key, unseen_notifications, isImpresonation, scope?.comments]);
}
